export enum MessageType {
  Mission_Refusal_Message = 'mission_refusal_message',
  Mission_Accept_Partial_Message = 'mission_accept_partial_message',
  Mission_Just_Shipped_Message = 'mission_just_shipped_message',
  Mission_Just_Confirmed = 'mission_just_confirmed',
  Scope_New_Assignation_Message = 'scope_new_assignation_message',
  Mission_New_Client_Assignation_Message = 'mission_new_client_assignation_message',
  Mission_New_Consultant_Assignation_Message = 'mission_new_consultant_assignation_message',
  Mission_Overdue_Message = 'mission_overdue_message',
  Mission_Bad_Ranking_Message = 'mission_bad_ranking_message',
  Deliverable_Sheet_New = 'deliverable_sheet_new',
}
